import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Modal, Form, Badge, OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap';
import SectionLoader from '../../../components/SectionLoader';
import { Link } from 'react-router-dom'
import axios from 'axios';
import { Multiselect } from "multiselect-react-dropdown";
import { info, error, warning, success } from "../../../notify";
import './Dropdown.css'


import DeleteConfirmation from './DeleteConfirmation';
import '../../../assets/scss/component.scss'
import RetrainConfirmation from './RetrainConfirmation';


const SiteDocs = (props) => {
    let history = useNavigate();
    const userRole = sessionStorage.getItem("userRole");
    const ERR_NETWORK_MESSAGE = 'Server is not available.'
    const token = sessionStorage.getItem("revizeTrainingToken");
    const [domainKey, setDomainKey] = useState("");
    const [domainName, setDomainName] = useState("");
    const [enableFileTrain, setEnableFileTrain] = useState(false);
    const [siteId, setSiteId] = useState("");
    const [siteData, setSiteData] = useState([]);
    const [filteredSiteData, setFilteredSiteData] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [updatedFiles, setUpdatedFiles] = useState([]);
    const [selectedUrls, setSelectedUrls] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [documentCategoryData, setDocumentCategoryData] = useState([]);
    const [documentCategoryAvailableData, setDocumentCategoryAvailableData] = useState([]);
    const siteApi = `${process.env.REACT_APP_SERVER_URL}/api/site-trained-doc/?siteId=`;
    const categorySiteApi = `${process.env.REACT_APP_SERVER_URL}/api/category-site/?siteId=`;
    const deleteDocumentApi = `${process.env.REACT_APP_SERVER_URL}/api/train/doc?uuid=`;
    const addDocumentFileApi = `${process.env.REACT_APP_SERVER_URL}/api/train/file?websiteRef=`;
    const addCategoryDocumentFileApi = `${process.env.REACT_APP_SERVER_URL}/api/train/file/category?websiteRef=`;
    const addDocumentUrlApi = `${process.env.REACT_APP_SERVER_URL}/api/train/url?websiteRef=`;
    const addCategoryDocumentUrlApi = `${process.env.REACT_APP_SERVER_URL}/api/train/url/category?websiteRef=`;
    const updateDocumentFileApi = `${process.env.REACT_APP_SERVER_URL}/api/train/file?uuid=`;
    const updateDocumentUrlApi = `${process.env.REACT_APP_SERVER_URL}/api/train/url?websiteRef=`;
    const updateDocumentAllUrlApi = `${process.env.REACT_APP_SERVER_URL}/api/train/all/url?websiteRef=`;
    const documentCategoryApi = `${process.env.REACT_APP_SERVER_URL}/api/trained-doc-category/`;
    const documentCategoryAvailableApi = `${process.env.REACT_APP_SERVER_URL}/api/trained-doc-category-available/?website_id=`;
    const querySearchApi = `${process.env.REACT_APP_SERVER_URL}/api/get_query_search`;
    const getPageLimitApi = `${process.env.REACT_APP_SERVER_URL}/api/get_page_limit/`;
    const setPageLimitURL = `${process.env.REACT_APP_SERVER_URL}/api/set-page-limit/`;
    const [uuid, setUuid] = useState(null);
    const [confirmMessage, setConfirmMessage] = useState(null);
    const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
    const [deleteDocumentCategoryConfirmationModal, setDeleteDocumentCategoryConfirmationModal] = useState(false);
    const [displayRetrainConfirmationModal, setDisplayRetrainConfirmationModal] = useState(false);
    const [displayRetrainAllUrlConfirmationModal, setDisplayRetrainAllUrlConfirmationModal] = useState(false);
    const [displayRetrainSelectedConfirmationModal, setDisplayRetrainSelectedConfirmationModal] = useState(false);


    const [showAddFile, setShowAddFile] = useState(false);
    const handleCloseAddFile = () => {
        setSelectedFiles([]);
        setSelectedCategories([]);
        setShowAddFile(false);
    }
    const handleShowAddFile = () => {
        getCategory();
        setShowAddFile(true);
    }
    const [showAddUrl, setShowAddUrl] = useState(false);
    const handleCloseAddUrl = () => {
        setSelectedUrls([]);
        setSelectedCategories([]);
        setShowAddUrl(false);
        setUrlError("");
    }
    const handleShowAddUrl = () => {
        getCategory();
        setShowAddUrl(true);
    }
    const [showUpdateFile, setShowUpdateFile] = useState(false);
    const [updateUuid, setUpdateUuid] = useState('');
    const [urlError, setUrlError] = useState('');
    const [proceedTrain, setProceedTrain] = useState(true);
    const [filterValue, setFilterValue] = useState('');
    const [selectedCategories, setSelectedCategories] = useState([]);


    const handleCloseUpdateFile = () => {
        setShowUpdateFile(false);
        setUpdatedFiles([]);
    }


    const [documentUuid, setDocumentUuid] = useState('')
    const [documentUrl, setDocumentUrl] = useState('')
    const [websiteRef, setWebsiteRef] = useState('')
    const [categoryUuid, setCategoryUuid] = useState(null)
    const [categoryDocumentId, setCategoryDocumentId] = useState(null)
    const [showDocumentCategory, setShowDocumentCategory] = useState(false);
    const handleCloseDocumentCategory = () => {
        setDocumentCategoryData([]);
        setSelectedCategories([]);
        fetchData(null, false);
        setShowDocumentCategory(false);
    }
    const handleShowDocumentCategory = (document_id, uuid, url) => {
        getDocumentCategoryAvailable(document_id);
        getDocumentCategory(uuid);
        setDocumentUuid(uuid);
        setDocumentUrl(url);
        setShowDocumentCategory(true);
    }


    // ========== Multi‑select state ==========
    const [selectedUuids, setSelectedUuids] = useState([]);
    const [showSelectionModal, setShowSelectionModal] = useState(true);
    // ========================================


    let loaded = false;
    const location = useLocation();


    useEffect(() => {
        if (!loaded && token) {
            // eslint-disable-next-line
            loaded = true;
            if (null === location.state) {
                history('/site')
                return;
            }
            setSiteId(location.state.siteId);
            setDomainKey(location.state.siteKey);
            setDomainName(location.state.siteName);
            setEnableFileTrain(location.state.enableFileTrain);
        }


    }, [domainKey])


    const [isLoading, setIsLoading] = useState(true);
    const offset = useRef(0);
    const fetchRequestIdRef = useRef(0);


    let current_page_limit = sessionStorage.getItem("current_page_limit")
    let previous_page_limit = sessionStorage.getItem("previous_page_limit")
    const [itemsPerPage, setItemsPerPage] = useState(sessionStorage.getItem("current_page_limit"));


    const fetchData = async (filter_value = null, shouldSetLoading = true, searchText = null) => {
        if (!siteId || !token) return;

        const requestId = ++fetchRequestIdRef.current;
        if (shouldSetLoading) {
            setIsLoading(true);
        }
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
            const loggedInUserId = sessionStorage.getItem("loggedInUserId");
            let pageLimit = null;


            try {
                // Fetch the page limit first
                if (loggedInUserId) {
                    console.log("sessionStorage.getItem(current_page_limit)", sessionStorage.getItem("current_page_limit"))
                    if (sessionStorage.getItem("current_page_limit") == null) {
                        if ((current_page_limit == null && previous_page_limit == null) || (current_page_limit && previous_page_limit && current_page_limit !== previous_page_limit)) {
                            try {
                                const pageLimitResponse = await axios.get(getPageLimitApi, {
                                    headers: headers,
                                    params: { user_id: loggedInUserId }
                                });


                                const pageLimitData = pageLimitResponse.data;
                                pageLimit = pageLimitData.page_limit;  // Assign page limit
                                setItemsPerPage(pageLimitData.page_limit);  // Set the itemsPerPage from API response
                                current_page_limit = pageLimit;
                                previous_page_limit = pageLimit;
                                sessionStorage.setItem('current_page_limit', pageLimit);
                                sessionStorage.setItem('previous_page_limit', pageLimit);
                            } catch (pageLimitErr) {
                                if (pageLimitErr.response) {
                                    error(pageLimitErr.response.data, true);
                                } else {
                                    console.error("Error fetching page limit:", pageLimitErr);
                                }
                                return;  // Stop further execution if fetching page limit fails
                            }
                        }
                    }
                }


                // Use the fetched pageLimit or existing itemsPerPage
                let limit = sessionStorage.getItem("current_page_limit") == null ? pageLimit : sessionStorage.getItem("current_page_limit");
                console.log("limit of siteDocs", limit)
                let url = `${siteApi}${siteId}&limit=${limit}&offset=${offset.current}`;
                if (filter_value) {
                    url += `&filter=${filter_value}`;
                }
                if (searchText) {
                    url += `&search_text=${encodeURIComponent(searchText)}`;
                }


                // Call the siteApi using the determined limit
                const response = await axios.get(url, { headers });
                if (requestId !== fetchRequestIdRef.current) return;
                const data = response.data;


                console.log("data received from site docs api", data);


                // Set both data and total count from the single API response
                setSiteData(data.data || []);
                setFilteredSiteData(data.data || []);
                setSiteDataLength(data.total_count || 0); // Set the total count


                isPageInitialized.current = true


            } catch (err) {
                if (requestId !== fetchRequestIdRef.current) return;
                if (err === 'ERR_NETWORK') {
                    error(ERR_NETWORK_MESSAGE, true);
                } else {
                    error(err.response.data, true);
                }
                history('/site');
            } finally {
                if (shouldSetLoading && requestId === fetchRequestIdRef.current) {
                    setIsLoading(false);
                }
            }
    };


    const selectFile = (event) => {
        setSelectedFiles([event.target.files[0]])
    };


    const updateFile = (event) => {
        setUpdatedFiles([event.target.files[0]])
    };


    const [, setIsUrlValid] = useState(false);

    const setUrl = (event) => {
        setSelectedUrls([event])
    };


    const onSelectCategories = (selectedList, selectedItem) => {
        setSelectedCategories([...selectedCategories, selectedItem.uuid]);
    };


    const onRemoveCategories = (selectedList, removedItem) => {
        setSelectedCategories(
            selectedCategories.filter((val) => {
                return val !== removedItem.uuid;
            })
        );
    }


    const getCategory = () => {
        if (token) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
            axios.get(categorySiteApi + siteId, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    setCategoryData(data);
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data, true)
                    }
                });
        }
    };


    const getDocumentCategoryAvailable = (document_id) => {
        if (token) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
            axios.get(documentCategoryAvailableApi + siteId + "&document_id=" + document_id, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    setDocumentCategoryAvailableData(data);
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data, true)
                    }
                });
        }
    };


    const getDocumentCategory = (uuid) => {
        if (token) {
            const headers = { "accept": "application/json", "Authorization": "Bearer " + token };
            axios.get(documentCategoryApi + uuid, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    // console.log(data);
                    setDocumentCategoryData(data);
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data, true)
                    }
                });
        }
    };


    const addDocumentCategoryFile = (documentUuid) => {
        if (token) {
            // console.log("documentUuid: " + documentUuid);
            const headers = { "Content-Type": "application/json", "accept": "application/json", "Authorization": "Bearer " + token };
            var data = JSON.stringify({
                "docUuid": documentUuid,
                "categories": selectedCategories
            });


            // console.log(data);


            axios.post(addCategoryDocumentFileApi + domainKey, data, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    info(
                        typeof data === "string"
                            ? data
                            : (data && data.message) || "Accepted file for training",
                        true
                    )
                    fetchData(null, false);
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data, true)
                    }
                });


            setSelectedFiles([]);
            setSelectedCategories([]);
        }
    };


    const addDocumentCategoryUrl = (documentUuid) => {
        if (token) {
            // console.log("documentUuid: " + documentUuid);
            const headers = { "Content-Type": "application/json", "accept": "application/json", "Authorization": "Bearer " + token };
            var data = JSON.stringify({
                "docUuid": documentUuid,
                "categories": selectedCategories
            });


            axios.post(addCategoryDocumentUrlApi + domainKey, data, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    info(
                        typeof data === "string"
                            ? data
                            : (data && data.message) || "Accepted URL for training",
                        true
                    )
                    // Not required for new changes.
                    // fetchData();
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data, true)
                    }
                });


            setSelectedCategories([]);
        }
    };


    const addFileDocument = () => {
        if (token) {
            let currentFile = selectedFiles[0];
            let formData = new FormData();
            formData.append("files", currentFile);
            formData.append("categories", selectedCategories);
            formData.append("docUuids", [])
            const headers = { "accept": "application/json", "Authorization": "Bearer " + token };


            axios.post(addDocumentFileApi + domainKey, formData, { headers: headers })
                .then((response) => {
                    const data = { ...response.data, categories: "", categoryCount: 0 };
                    setSiteData(oldData => [...oldData, data]);
                    setFilteredSiteData(oldData => [...oldData, data]);
                    info("Accepted file for training", true)
                    fetchData(null, false);
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data, true)
                    }
                });


            setSelectedFiles([]);
            setSelectedCategories([]);
        }
    };


    const addUrlDocument = () => {
        if (token) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
            var data = JSON.stringify({ "urls": selectedUrls, "categories": selectedCategories });


            axios.post(addDocumentUrlApi + domainKey, data, { headers: headers })
                .then((response) => {
                    const data = { ...response.data, categories: "", categoryCount: 0 };
                    setSiteData(oldData => [...oldData, data]);
                    setFilteredSiteData(oldData => [...oldData, data]);
                    info("Accepted URL for training.", true);
                    // Not required for new changes.
                    // fetchData();
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data, true)
                    }
                });


            setSelectedCategories([]);
        }
    };


    const updateFileDocument = () => {
        if (token) {
            let formData = new FormData();
            formData.append("file", updatedFiles[0]);
            const headers = { "accept": "application/json", "Authorization": "Bearer " + token };


            axios.put(updateDocumentFileApi + updateUuid + "&websiteRef=" + domainKey, formData, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    updateSiteData(data.uuid, data.status)
                    info("Accepted URL for updation.", true);
                    fetchData(null, false);
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data, true)
                    }
                });


            setUpdatedFiles([]);
            setSelectedCategories([]);
        }
    };


    const updateUrlDocument = () => {
        if (token) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
            var data = JSON.stringify({ "url": selectedUrls[0], "uuids": [uuid] });


            axios.put(updateDocumentUrlApi + domainKey, data, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    updateSiteData(data.uuid, data.status)
                    info("Accepted URL for updation.", true);
                    // Not required for new changes.
                    fetchData(null, false);
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data, true)
                    }
                });
        }
        setDisplayRetrainConfirmationModal(false);
    };


    const updateAllUrlDocument = () => {
        if (token) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };


            axios.put(updateDocumentAllUrlApi + domainKey, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    if (data.length > 0) {
                        updateAllUrlSiteData(data);
                        info("Accepted all url for updation", true);
                    }
                    else {
                        error("THERE ARE NO URLs FOR TRAINING", true);
                    }
                    // Not required for new changes.
                    // fetchData();
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data, true)
                    }
                });
        }
        setDisplayRetrainAllUrlConfirmationModal(false);
    };


    const updateSelectedUrlDocuments = () => {
        if (token) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };


            // Only retrain URL-type docs (items that have a url)
            const urlUuids = selectedUuids.filter(uid => {
                const item = siteData.find(d => d.uuid === uid);
                return item && item.url && item.url.length > 0;
            });


            if (urlUuids.length === 0) {
                error("None of the selected items are URL documents.", true);
                setDisplayRetrainSelectedConfirmationModal(false);
                return;
            }


            axios.put(updateDocumentUrlApi + domainKey, { uuids: urlUuids }, { headers })
                .then((response) => {
                    console.log("Response from updateSelectedUrlDocuments API", response.data);
                    const { updated = [], errors: errs = [] } = response.data;
                    if (updated.length > 0) {
                        // Update statuses in the table
                        const updatedMap = {};
                        updated.forEach(doc => { updatedMap[doc.uuid] = doc.status; });
                        setSiteData(prev => prev.map(item =>
                            updatedMap[item.uuid] ? { ...item, status: updatedMap[item.uuid] } : item
                        ));
                        setFilteredSiteData(prev => prev.map(item =>
                            updatedMap[item.uuid] ? { ...item, status: updatedMap[item.uuid] } : item
                        ));
                        info(`${updated.length} URL(s) accepted for retraining.`, true);
                    }
                    if (errs.length > 0) {
                        error(`${errs.length} URL(s) failed to queue for retraining.`, true);
                    }
                    clearSelection();
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true);
                    } else {
                        error(err.response?.data || 'An error occurred.', true);
                    }
                });
        }
        setDisplayRetrainSelectedConfirmationModal(false);
    };


    const updateAllUrlSiteData = (data) => {
        // map over the todos
        data.map((respItem) => {
            const updatedArray = siteData.map((item) => {
                // return the updated todo when we find the same id
                if (respItem.uuid === item.uuid) {
                    item.status = respItem.status;
                    return item;
                }


                return item;
            });
            setSiteData(updatedArray);
            return updatedArray;
        });
    };


    // Single row delete — removes the row from UI immediately
    const deleteDocument = () => {
        const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
        const uuidsToDelete = uuid ? [uuid] : [];


        axios.delete(deleteDocumentApi, {
            data: { uuids: uuidsToDelete, websiteRef: domainKey },
            headers: headers
        })
            .then((response) => {
                info(response.data.message, true);
                setSiteData(prev => prev.filter(item => !uuidsToDelete.includes(item.uuid)));
                setFilteredSiteData(prev => prev.filter(item => !uuidsToDelete.includes(item.uuid)));
                setSiteDataLength(prev => prev - uuidsToDelete.length);
            })
            .catch((err) => {
                if (err === 'ERR_NETWORK') {
                    error(ERR_NETWORK_MESSAGE, true);
                } else {
                    error(err.response.data, true);
                }
            });


        setDeleteConfirmationModal(false);
    };


    // Bulk delete (Delete Selected) — marks rows as TO_DELETE in UI
    const deleteSelectedDocuments = () => {
        const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
        const uuidsToDelete = selectedUuids;


        axios.delete(deleteDocumentApi, {
            data: { uuids: uuidsToDelete, websiteRef: domainKey },
            headers: headers
        })
            .then((response) => {
                info(response.data.message, true);
                const uuidSet = new Set(uuidsToDelete);
                setSiteData(prev => prev.map(item => uuidSet.has(item.uuid) ? { ...item, status: 'TO_DELETE' } : item));
                setFilteredSiteData(prev => prev.map(item => uuidSet.has(item.uuid) ? { ...item, status: 'TO_DELETE' } : item));
                clearSelection();
            })
            .catch((err) => {
                if (err === 'ERR_NETWORK') {
                    error(ERR_NETWORK_MESSAGE, true);
                } else {
                    error(err.response.data, true);
                }
            });


        setDeleteSelectedConfirmationModal(false);
    };


    const deleteCategoryDocument = () => {
        const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
        var data = JSON.stringify({
            "websiteRef": websiteRef,
            "category": categoryUuid,
            "categoryDocumentId": categoryDocumentId
        });


        axios.delete(deleteDocumentApi + documentUuid, { data: data, headers: headers })
            .then((response) => {
                const data = response.data;
                info(
                    typeof data === "string"
                        ? data
                        : (data && data.message) || "Document category removed",
                    true
                );


                // Update documentCategoryData state
                const newDocumentCategoryData = documentCategoryData.filter((val) => {
                    return val.category_uuid !== categoryUuid;
                });
                setDocumentCategoryData(newDocumentCategoryData);


                // Also update the main site data if needed
                fetchData(null, false);
            })
            .catch((err) => {
                if (err === 'ERR_NETWORK') {
                    error(ERR_NETWORK_MESSAGE, true)
                } else {
                    error(err.response.data, true)
                }
            });


        setDeleteDocumentCategoryConfirmationModal(false);
        setCategoryUuid(null);
        setCategoryDocumentId(null);
    };


    const updateSiteData = (uuid, status) => {
        const currentSiteDataIndex = siteData.findIndex((siteData) => siteData.uuid === uuid);
        const updatedSiteData = Object.assign({}, siteData[currentSiteDataIndex]);
        updatedSiteData.status = status;
        const newSiteData = siteData.slice();
        newSiteData[currentSiteDataIndex] = updatedSiteData;
        setSiteData(newSiteData);
    };


    const showDeleteModal = (uuid, docName) => {
        setUuid(uuid);
        setConfirmMessage("Are you sure you want to delete the document: " + docName + "? This will be deleted permanently and can not be rolled back.");
        setDeleteConfirmationModal(true);
        loaded = true;
    };


    const showDeleteCategoryModal = (document_uuid, website_ref, category_uuid, id, category) => {
        setDocumentUuid(document_uuid);
        setWebsiteRef(website_ref);
        setCategoryUuid(category_uuid);
        setCategoryDocumentId(id);
        setConfirmMessage("Are you sure you want to delete the category: " + category + " for this document? This will be deleted permanently and can not be rolled back.");
        setDeleteDocumentCategoryConfirmationModal(true);
        loaded = true;
    };


    const showRetrainModal = (uuid, url, status) => {
        const allow_train_status = ['TRAINED', 'RETRAINED', 'FAILED']
        if (allow_train_status.includes(status)) {
            setUuid(uuid);
            setUrl(url);
            setConfirmMessage("Are you sure you want to retrain with url: " + url + "? This will update old content of this url with new content and can not be rolled back.");
            setDisplayRetrainConfirmationModal(true);
            loaded = true;
            setProceedTrain(true);
        } else {
            setConfirmMessage("The URL is in " + status + " status and cannot be trained/retrained.");
            setDisplayRetrainConfirmationModal(true);
            loaded = true;
            setProceedTrain(false);
        }
    };


    const handleShowRetrainAllUrl = () => {
        setConfirmMessage("Are you sure you want to retrain all url in this site? This will update old content of these urls with new content and can not be rolled back.");
        setDisplayRetrainAllUrlConfirmationModal(true);
        loaded = true;
    };


    const hideRetrainAllUrlConfirmationModal = () => {
        setDisplayRetrainAllUrlConfirmationModal(false);
    }


    const handleShowRetrainSelected = () => {
        const urlCount = selectedUuids.filter(uid => {
            const item = siteData.find(d => d.uuid === uid);
            return item && item.url && item.url.length > 0;
        }).length;
        const fileCount = selectedUuids.length - urlCount;


        let msg = `Are you sure you want to retrain ${urlCount} selected URL document(s)?`;
        if (fileCount > 0) {
            msg += ` (${fileCount} file document(s) will be skipped as bulk retrain only supports URLs.)`;
        }
        msg += ' This will update old content with new content and cannot be rolled back.';
        setConfirmMessage(msg);
        setDisplayRetrainSelectedConfirmationModal(true);
    };


    const hideRetrainSelectedConfirmationModal = () => {
        setDisplayRetrainSelectedConfirmationModal(false);
    };


    // Hide the modal
    const hideDeleteConfirmationModal = () => {
        setDeleteConfirmationModal(false);
    };


    const hideDeleteDocumentCategoryConfirmationModal = () => {
        setDeleteDocumentCategoryConfirmationModal(false);
    };


    const hideRetrainConfirmationModal = () => {
        setDisplayRetrainConfirmationModal(false);
    }


    const handleShowRetrainFile = (uuid, status) => {
        const allow_train_status = ['TRAINED', 'RETRAINED', 'FAILED']
        if (allow_train_status.includes(status)) {
            setUpdateUuid(uuid);
            getCategory();
            setShowUpdateFile(true);
        } else {
            setShowUpdateFile(false);
            warning('Cannot Train/Retrain the Page/Doc.');
        }
    }


    const filterSiteDocs = (value) => {
        setFilterValue(value);
        setCurrentPage(1);
        setCurrentRangeStart(1);
        offset.current = 0;
        fetchData(value, true, searchInputValue);
    }


    const refreshData = async () => {
        const newOffset = (currentPage - 1) * itemsPerPage;
        offset.current = newOffset;
        await fetchData(filterValue, true, searchInputValue);
        success("Trained documents refreshed successfully.", true);
    };


    const handleDropdownOpen = () => {
        const dropdown = document.querySelector('.multiselect-container');
        if (dropdown) {
            dropdown.scrollTop = 0;  // Scroll to the top
        }
    }


    const checkURLOnCHange = (event) => {
        const urlValue = event.target.value;
        setSelectedUrls([urlValue]);


        const urlPattern = /^(http[s]?:\/\/)(www\.)?[^\s$.?#].[^\s]*$/;
        const isValidURL = urlPattern.test(urlValue);


        if (isValidURL) {
            setUrlError("");
            setIsUrlValid(true);
        } else {
            setUrlError("URL is invalid");
            setIsUrlValid(false);
        }
    }


    const [currentPage, setCurrentPage] = useState(1);
    const [currentRangeStart, setCurrentRangeStart] = useState(1);
    const [siteDataLength, setSiteDataLength] = useState(0)


    const pagesToShow = 10;
    const totalPages = Math.ceil(siteDataLength / itemsPerPage);
    console.log("total pages", totalPages)


    const paginate = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            offset.current = (pageNumber - 1) * itemsPerPage;
            fetchData(filterValue, true, searchInputValue);
        }
    };


    // Handlers for pagination range navigation
    const handleNextRange = () => {
        if (currentRangeStart + pagesToShow <= totalPages) {
            setCurrentRangeStart(currentRangeStart + pagesToShow);
        }
    };


    const handlePrevRange = () => {
        if (currentRangeStart - pagesToShow > 0) {
            setCurrentRangeStart(currentRangeStart - pagesToShow);
        }
    };


    // Page numbers based on current range
    const visiblePageNumbers = Array.from(
        { length: Math.min(pagesToShow, totalPages - currentRangeStart + 1) },
        (_, index) => currentRangeStart + index
    );


    useEffect(() => {
        if (siteId && token) {
            fetchData(filterValue, true, searchInputValue); // Fetch initial data (includes count)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteId, token, filterValue]);


    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1);
    };


    const isPageInitialized = useRef(false);


    useEffect(() => {
        const setPageLimit = async () => {
            const headers = {
                "accept": "application/json",
                "Authorization": "Bearer " + token
            };
            const loggedInUserId = sessionStorage.getItem("loggedInUserId");
            if (itemsPerPage != null) {
                try {
                    await axios.post(setPageLimitURL,
                        {
                            page_limit: itemsPerPage
                        },
                        {
                            headers: headers,
                            params: { user_id: loggedInUserId }
                        }
                    );


                    sessionStorage.setItem('current_page_limit', itemsPerPage);
                    sessionStorage.setItem('previous_page_limit', itemsPerPage);


                    fetchData(filterValue, true, searchInputValue);
                }
                catch (setLimitErr) {
                    console.error('Error setting page limit:', setLimitErr);
                    error('Error setting page limit', true);
                }
            }
        };


        if (isPageInitialized.current === true) {
            setPageLimit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsPerPage]);


    const [showSearchField, setShowSearchField] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [querySearchTerm, setQuerySearchTerm] = useState('');



    const handleSearchClick = () => {
        setShowSearchField(!showSearchField);
    };


    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };


    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            const trimmedQuery = searchQuery.trim();
            if (trimmedQuery !== '') {
                event.preventDefault();
                setIsLoading(true);
                setShowSearchField(false);
                setQuerySearchTerm(trimmedQuery);
                setSearchQuery('');
                setSiteData([]);
                setFilteredSiteData([]);
                clearSelection();
                setShowPageNumbers(false);
                fetchQuerySource(trimmedQuery);
            }
        }
    };


    const handleQuerySearch = (event) => {
        const trimmedQuery = searchQuery.trim();
        if (trimmedQuery !== '') {
            event.preventDefault();
            setIsLoading(true);
            setShowSearchField(false);
            setQuerySearchTerm(trimmedQuery);
            setSearchQuery('');
            setSiteData([]);
            setFilteredSiteData([]);
            clearSelection();
            setShowPageNumbers(false);
            fetchQuerySource(trimmedQuery);
        }
    };


    const fetchQuerySource = (query) => {
        const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };


        const params = {
            query,
            websiteRef: domainKey,
            siteId: siteId
        };


        axios.get(querySearchApi, { params: params, headers: headers })
            .then((response) => {
                const data = response.data;
                setSiteData(data);
                setFilteredSiteData(data);
                setSiteDataLength(data.length || 0);
            })
            .catch((err) => {
                if (err === 'ERR_NETWORK') {
                    error(ERR_NETWORK_MESSAGE, true);
                } else {
                    error(err.response.data, true);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };


    const [showPageNumbers, setShowPageNumbers] = useState(true);


    const auditLogsParams = {
        siteId: siteId,
        siteName: domainName,
        siteKey: domainKey,
        enableFileTrain: enableFileTrain
    };


    // Store in localStorage
    localStorage.setItem("auditLogsParams", JSON.stringify(auditLogsParams));


    // New search functionality
    const [searchInputValue, setSearchInputValue] = useState("");
    const [showClearButton, setShowClearButton] = useState(false);


    const handleSearch = async () => {
        if (searchInputValue.trim() !== "") {
            setShowClearButton(true);
        }
        setCurrentPage(1);
        setCurrentRangeStart(1);
        const newOffset = 0;
        offset.current = newOffset;
        await fetchData(filterValue, true, searchInputValue);
    };


    const handleClearSearch = async () => {
        setSearchInputValue("");
        setShowClearButton(false);
        setCurrentPage(1);
        setCurrentRangeStart(1);
        const newOffset = 0;
        offset.current = newOffset;
        await fetchData(filterValue, true, null);
    };


    const handleSearchInputChange = (event) => {
        setSearchInputValue(event.target.value);
        if (event.target.value.trim() === "") {
            setShowClearButton(false);
            handleClearSearch();
        }
    };


    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };


    // Helper function to truncate HTML/Markdown text safely
    const truncateText = (text, maxLength = 100) => {
        if (!text) return "N/A";


        if (text.length <= maxLength) {
            return text;
        }


        let truncated = text.substring(0, maxLength);
        const lastTagIndex = truncated.lastIndexOf('<');
        const lastCloseTagIndex = truncated.lastIndexOf('>');


        if (lastTagIndex > lastCloseTagIndex) {
            truncated = truncated.substring(0, lastTagIndex);
        }


        return `${truncated}...`;
    };


    const truncateDomain = (text, maxLength = 15) => {
        if (!text) return "";


        if (text.length <= maxLength) {
            return text;
        }


        return `${text.substring(0, maxLength)}...`;
    };


    const formatTimestamp = (timestamp) => {
        if (!timestamp) return "N/A";
        const date = new Date(timestamp);
        const formattedDate = date.toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "2-digit",
        });
        const formattedTime = date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        });
        return `${formattedDate}, ${formattedTime}`;
    };


    useEffect(() => {
        let timer;


        if (selectedUuids.length > 0) {
            setShowSelectionModal(true);


            timer = setTimeout(() => {
                setShowSelectionModal(false);
            }, 10000); // 10 seconds
        }


        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [selectedUuids]);


    // Icons
    const EditIcon = () => (
        <svg width="16" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.7476 20.4428H21.0002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M12.78 3.79479C13.5557 2.86779 14.95 2.73186 15.8962 3.49173C15.9485 3.53296 17.6295 4.83879 17.6295 4.83879C18.669 5.46719 18.992 6.80311 18.3494 7.82259C18.3153 7.87718 8.81195 19.7645 8.81195 19.7645C8.49578 20.1589 8.01583 20.3918 7.50291 20.3973L3.86353 20.443L3.04353 16.9723C2.92866 16.4843 3.04353 15.9718 3.3597 15.5773L12.78 3.79479Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.021 6.00098L16.4732 10.1881" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );


    const DeleteIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );


    const RefreshIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5a6acf" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 2v6h6"></path>
            <path d="M21 12a9 9 0 0 0-15-6.7L3 8"></path>
            <path d="M21 22v-6h-6"></path>
            <path d="M3 12a9 9 0 0 0 15 6.7L21 16"></path>
        </svg>
    );


    const BackIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
            <line x1="5" y1="6" x2="5" y2="18"></line>
        </svg>
    );


    const SearchIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
    );


    const ClearIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    );


    const AuditLogsIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 2V8H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 13H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 17H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 9H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );


    const ChatHistoryIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 3H7C4.79086 3 3 4.79086 3 7V15C3 17.2091 4.79086 19 7 19H17C19.2091 19 21 17.2091 21 15V7C21 4.79086 19.2091 3 17 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 8H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 12H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 16H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );


    const ConfigurationsIcon = () => (
        <svg width="16" height="16" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M51.22,21h-5.052c-0.812,0-1.481-0.447-1.792-1.197s-0.153-1.54,0.420-2.114l3.572-3.571 c0.525-0.525,0.814-1.224,0.814-1.966c0-0.743-0.289-1.441-0.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933,0l-3.571,3.571 c-0.574,0.573-1.366,0.733-2.114,0.421C33.447,9.313,33,8.644,33,7.832V2.78C33,1.247,31.753,0,30.22,0H23.78 C22.247,0,21,1.247,21,2.78v5.052c0,0.812-0.447,1.481-1.197,1.792c-0.748,0.313-1.54,0.152-2.114-0.421l-3.571-3.571 c-1.052-1.052-2.883-1.05-3.933,0l-4.553,4.553c-0.525,0.525-0.814,1.224-0.814,1.967c0,0.742,0.289,1.44,0.814,1.966l3.572,3.571 c0.573,0.574,0.73,1.364,0.420,2.114S8.644,21,7.832,21H2.78C1.247,21,0,22.247,0,23.78v6.439C0,31.753,1.247,33,2.78,33h5.052 c0.812,0,1.481,0.447,1.792,1.197s0.153,1.54-0.420,2.114l-3.572,3.571c-0.525,0.525-0.814,1.224-0.814,1.966 c0,0.743,0.289,1.441,0.814,1.967l4.553,4.553c1.051,1.051,2.881,1.053,3.933,0l3.571-3.572c0.574-0.573,1.363-0.731,2.114-0.42 c0.75,0.311,1.197,0.98,1.197,1.792v5.052c0,1.533,1.247,2.78,2.78,2.78h6.439c1.533,0,2.78-1.247,2.78-2.78v-5.052 c0-0.812,0.447-1.481,1.197-1.792c0.751-0.312,1.54-0.153,2.114,0.420l3.571,3.572c1.052,1.052,2.883,1.05,3.933,0l4.553-4.553 c0.525-0.525,0.814-1.224,0.814-1.967c0-0.742-0.289-1.44-0.814-1.966l-3.572-3.571c-0.573-0.574-0.73-1.364-0.420-2.114 S45.356,33,46.168,33h5.052c1.533,0,2.78-1.247,2.78-2.78V23.78C54,22.247,52.753,21,51.22,21z" stroke="currentColor" strokeWidth="1.5" />
            <path d="M27,18c-4.963,0-9,4.037-9,9s4.037,9,9,9s9-4.037,9-9S31.963,18,27,18z" stroke="currentColor" strokeWidth="2" />
        </svg>
    );


    const CustomizeChatIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 20h9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );


    const ManageCategoryIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M3 6.5C3 3.87479 3.02811 3 6.5 3C9.97189 3 10 3.87479 10 6.5C10 9.12521 10.0111 10 6.5 10C2.98893 10 3 9.12521 3 6.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M14 6.5C14 3.87479 14.02811 3 17.5 3C20.9719 3 21 3.87479 21 6.5C21 9.12521 21.0111 10 17.5 10C13.9889 10 14 9.12521 14 6.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M3 17.5C3 14.8748 3.02811 14 6.5 14C9.97189 14 10 14.8748 10 17.5C10 20.1252 10.0111 21 6.5 21C2.98893 21 3 20.1252 3 17.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M14 17.5C14 14.8748 14.02811 14 17.5 14C20.9719 14 21 14.8748 21 17.5C21 20.1252 21.0111 21 17.5 21C13.9889 21 14 20.1252 14 17.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );


    const ManageUserIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.8877 10.8967C19.2827 10.7007 20.3567 9.50473 20.3597 8.05573C20.3597 6.62773 19.3187 5.44373 17.9537 5.21973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.7285 14.2505C21.0795 14.4525 22.0225 14.9255 22.0225 15.9005C22.0225 16.5715 21.5785 17.0075 20.8605 17.2815" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M11.8867 14.6638C8.67273 14.6638 5.92773 15.1508 5.92773 17.0958C5.92773 19.0398 8.65573 19.5408 11.8867 19.5408C15.1007 19.5408 17.8447 19.0588 17.8447 17.1128C17.8447 15.1668 15.1177 14.6638 11.8867 14.6638Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M11.8869 11.888C13.9959 11.888 15.7059 10.179 15.7059 8.069C15.7059 5.96 13.9959 4.25 11.8869 4.25C9.7779 4.25 8.0679 5.96 8.0679 8.069C8.0599 10.171 9.7569 11.881 11.8589 11.888H11.8869Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.88509 10.8967C4.48909 10.7007 3.41609 9.50473 3.41309 8.05573C3.41309 6.62773 4.45409 5.44373 5.81909 5.21973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.044 14.2505C2.693 14.4525 1.75 14.9255 1.75 15.9005C1.75 16.5715 2.194 17.0075 2.912 17.2815" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );


    const ExcludedDomainsIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
            <line x1="7" y1="7" x2="17" y2="17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );


    const getStatusStyle = (status) => {
        let borderColor, bgColor, textColor;
        switch (status) {
            case "TRAINED":
                borderColor = "#5A6ACF";
                bgColor = "#EAF0FF";
                textColor = "#5A6ACF";
                break;
            case "RETRAINED":
                borderColor = "#E2A03F";
                bgColor = "#FFF6E8";
                textColor = "#E2A03F";
                break;
            case "FAILED":
                borderColor = "#DC3545";
                bgColor = "#FDECEC";
                textColor = "#DC3545";
                break;
            case "PENDING":
                borderColor = "#F4C20D";
                bgColor = "#FFF9E6";
                textColor = "#F4C20D";
                break;
            case "DELETED":
                borderColor = "#6C757D";
                bgColor = "#F8F9FA";
                textColor = "#6C757D";
                break;
            case "TO_DELETE":
                borderColor = "#DC3545";
                bgColor = "#FDECEC";
                textColor = "#DC3545";
                break;
            default:
                borderColor = "#6C757D";
                bgColor = "#F8F9FA";
                textColor = "#6C757D";
        }
        return {
            border: `1px solid ${borderColor}`,
            backgroundColor: bgColor,
            color: textColor,
            borderRadius: '6px',
            padding: '2px 8px',
            fontSize: '12px',
            fontWeight: 500,
            cursor: 'default',
        };
    };


    // ========== Multi‑select handlers ==========
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allUuids = filteredSiteData.map(item => item.uuid);
            setSelectedUuids(allUuids);
        } else {
            setSelectedUuids([]);
        }
    };


    const handleSelectRow = (uuid) => {
        setSelectedUuids(prev => {
            if (prev.includes(uuid)) {
                return prev.filter(id => id !== uuid);
            } else {
                return [...prev, uuid];
            }
        });
    };


    const clearSelection = () => {
        setSelectedUuids([]);
    };


    const [deleteSelectedConfirmationModal, setDeleteSelectedConfirmationModal] = useState(false);


    const handleFloatingDelete = () => {
        setConfirmMessage(`Are you sure you want to delete ${selectedUuids.length} selected document(s)? This will be deleted permanently and cannot be rolled back.`);
        setDeleteSelectedConfirmationModal(true);
    };


    const [deleteAllConfirmationModal, setDeleteAllConfirmationModal] = useState(false);


    const showDeleteAllModal = () => {
        setConfirmMessage(`Are you sure you want to delete ALL documents for this site? This will permanently delete all trained documents and cannot be rolled back.`);
        setDeleteAllConfirmationModal(true);
    };


    const hideDeleteAllConfirmationModal = () => {
        setDeleteAllConfirmationModal(false);
    };


    const deleteAllDocuments = () => {
        const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
        axios.delete(deleteDocumentApi, {
            data: {
                uuids: [],
                websiteRef: domainKey,
                delete_all_records: true
            },
            headers: headers
        })
            .then((response) => {
                const data = response.data;
                info(data.message, true);
                // Update all visible records' status to TO_DELETE instead of removing them
                setSiteData(prev => prev.map(item => ({ ...item, status: 'TO_DELETE' })));
                setFilteredSiteData(prev => prev.map(item => ({ ...item, status: 'TO_DELETE' })));
                clearSelection();
            })
            .catch((err) => {
                if (err === 'ERR_NETWORK') {
                    error(ERR_NETWORK_MESSAGE, true);
                } else {
                    error(err.response?.data || 'An error occurred.', true);
                }
            });
        setDeleteAllConfirmationModal(false);
    };


    // Calculate colSpan for table rows that span all columns
    const extraCol = (userRole !== "ADMIN" && siteId === 'All') ? 1 : 0;
    const colSpan = 1 + extraCol + 5; // checkbox + (optional client) + (title, category, status, actions, last trained)


    return (
        <div style={{
            fontFamily: '"Inter", sans-serif',
            background: '#f8f9fd',
            margin: 0,
            padding: '20px',
            minHeight: '100vh',
            overflowX: 'auto',
            width: '100%'
        }}>
            <style>{`
                #filter-dropdown ~ .dropdown-menu .dropdown-item:hover,
                #filter-dropdown ~ .dropdown-menu .dropdown-item:focus,
                #actions-dropdown ~ .dropdown-menu .dropdown-item:not(:disabled):hover,
                #actions-dropdown ~ .dropdown-menu .dropdown-item:not(:disabled):focus,
                #goto-dropdown ~ .dropdown-menu .dropdown-item:hover,
                #goto-dropdown ~ .dropdown-menu .dropdown-item:focus {
                    color: #5a6acf !important;
                    background-color: #f0f3ff;
                }
                #filter-dropdown:focus,
                #filter-dropdown:active,
                #filter-dropdown.show,
                #actions-dropdown:focus,
                #actions-dropdown:active,
                #actions-dropdown.show,
                #goto-dropdown:focus,
                #goto-dropdown:active,
                #goto-dropdown.show {
                    border-color: #5a6acf !important;
                    box-shadow: 0 0 0 0.2rem rgba(90, 106, 207, 0.25) !important;
                    outline: none !important;
                }
            `}</style>
            <div style={{
                background: '#fff',
                borderRadius: '16px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                padding: '20px',
                minWidth: '1200px'
            }}>
                {/* Header Section */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap', gap: '12px' }}>
                    <h2 style={{ fontSize: '20px', margin: 0, fontWeight: 600, minWidth: '300px' }}>
                        Trained Documents/Pages - {truncateDomain(domainName)}
                    </h2>


                    {/* Center group: search, filter, actions */}
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        {/* Search Box with Button */}
                        <div style={{ position: 'relative', width: '350px', minWidth: '250px' }}>
                            <input
                                type="text"
                                placeholder="Search documents..."
                                value={searchInputValue}
                                onChange={handleSearchInputChange}
                                onKeyPress={handleSearchKeyPress}
                                style={{
                                    width: '100%',
                                    padding: '8px 68px 8px 12px',
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    fontSize: '14px'
                                }}
                            />
                            <div style={{
                                position: 'absolute',
                                right: '4px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                gap: '4px',
                                alignItems: 'center'
                            }}>
                                {showClearButton && (
                                    <Button
                                        variant="outline-secondary"
                                        onClick={handleClearSearch}
                                        style={{
                                            background: '#5a6acf',
                                            borderRadius: '8px',
                                            width: '28px',
                                            height: '28px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '0',
                                            cursor: 'pointer',
                                            color: '#5a6acf',
                                            transition: 'all 0.2s ease-in-out',
                                            border: '1px solid #ddd',
                                            backgroundColor: 'white',
                                            boxShadow: '0 1px 1px rgba(0, 0, 0, 0.15)',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#5a6acf';
                                            e.currentTarget.style.color = 'white';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'white';
                                            e.currentTarget.style.color = '#5a6acf';
                                        }}
                                    >
                                        <ClearIcon />
                                    </Button>
                                )}
                                <Button
                                    variant="primary"
                                    onClick={handleSearch}
                                    style={{
                                        background: '#5a6acf',
                                        borderRadius: '8px',
                                        width: '28px',
                                        height: '28px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '0',
                                        cursor: 'pointer',
                                        color: '#5a6acf',
                                        transition: 'all 0.2s ease-in-out',
                                        border: '1px solid #ddd',
                                        backgroundColor: 'white',
                                        boxShadow: '0 1px 1px rgba(0, 0, 0, 0.15)',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#5a6acf';
                                        e.currentTarget.style.color = 'white';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'white';
                                        e.currentTarget.style.color = '#5a6acf';
                                    }}
                                >
                                    <SearchIcon />
                                </Button>
                            </div>
                        </div>


                        <Dropdown>
                            <Dropdown.Toggle variant="outline-secondary" id="filter-dropdown" style={{
                                background: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px 14px',
                                fontSize: '14px',
                                color: '#5a6acf',
                                cursor: 'pointer',
                                whiteSpace: 'nowrap',
                                width: '100px'
                            }}>
                                {filterValue || 'All'}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => filterSiteDocs('')}>All</Dropdown.Item>
                                <Dropdown.Item onClick={() => filterSiteDocs('Trained')}>Trained</Dropdown.Item>
                                <Dropdown.Item onClick={() => filterSiteDocs('Pending')}>Pending</Dropdown.Item>
                                <Dropdown.Item onClick={() => filterSiteDocs('Failed')}>Failed</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>


                        {/* Actions Dropdown */}
                        <Dropdown>
                            <Dropdown.Toggle variant="outline-secondary" id="actions-dropdown" style={{
                                background: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px 14px',
                                fontSize: '14px',
                                color: '#5a6acf',
                                cursor: 'pointer',
                                whiteSpace: 'nowrap',
                                width: '100px'
                            }}>
                                Actions
                            </Dropdown.Toggle>


                            <Dropdown.Menu>
                                {/* Group 1: Train new / Find source */}
                                {enableFileTrain && (
                                    <Dropdown.Item onClick={handleShowAddFile}>Train File</Dropdown.Item>
                                )}
                                <Dropdown.Item onClick={handleShowAddUrl}>Train New</Dropdown.Item>
                                <Dropdown.Item onClick={handleSearchClick}>Find Source</Dropdown.Item>


                                <Dropdown.Divider />


                                {/* Group 2: Retrain */}
                                <OverlayTrigger
                                    placement="right"
                                    overlay={
                                        selectedUuids.length === 0
                                            ? <Tooltip id="tooltip-retrain-selected">Please select some items to enable this option</Tooltip>
                                            : <span />
                                    }
                                >
                                    <span style={{ display: 'block' }}>
                                        <Dropdown.Item
                                            onClick={selectedUuids.length > 0 ? handleShowRetrainSelected : undefined}
                                            disabled={selectedUuids.length === 0}
                                            style={{
                                                color: selectedUuids.length === 0 ? '#adb5bd' : '#5a6acf',
                                                cursor: selectedUuids.length === 0 ? 'not-allowed' : 'pointer',
                                                opacity: selectedUuids.length === 0 ? 0.6 : 1,
                                                pointerEvents: 'auto',
                                            }}
                                        >
                                            Retrain Selected
                                        </Dropdown.Item>
                                    </span>
                                </OverlayTrigger>
                                <Dropdown.Item onClick={handleShowRetrainAllUrl}>Retrain All</Dropdown.Item>


                                <Dropdown.Divider />


                                {/* Group 3: Delete */}
                                <OverlayTrigger
                                    placement="right"
                                    overlay={
                                        selectedUuids.length === 0
                                            ? <Tooltip id="tooltip-delete-selected">Please select some items to enable this option</Tooltip>
                                            : <span />
                                    }
                                >
                                    <span style={{ display: 'block' }}>
                                        <Dropdown.Item
                                            onClick={selectedUuids.length > 0 ? handleFloatingDelete : undefined}
                                            disabled={selectedUuids.length === 0}
                                            style={{
                                                color: selectedUuids.length === 0 ? '#adb5bd' : '#dc3545',
                                                cursor: selectedUuids.length === 0 ? 'not-allowed' : 'pointer',
                                                opacity: selectedUuids.length === 0 ? 0.6 : 1,
                                                pointerEvents: 'auto',
                                            }}
                                        >
                                            Delete Selected
                                        </Dropdown.Item>
                                    </span>
                                </OverlayTrigger>
                                <Dropdown.Item
                                    onClick={showDeleteAllModal}
                                    style={{ color: '#dc3545', cursor: 'pointer' }}
                                >
                                    Delete All
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>


                        {/* Goto Dropdown */}
                        <Dropdown>
                            <Dropdown.Toggle variant="outline-secondary" id="goto-dropdown" style={{
                                background: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px 14px',
                                fontSize: '14px',
                                color: '#5a6acf',
                                cursor: 'pointer',
                                whiteSpace: 'nowrap',
                                width: '100px'
                            }}>
                                Goto
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    as={Link}
                                    to="/site/audit_logs"
                                    state={{ siteId, siteName: domainName, siteKey: domainKey, enableFileTrain }}
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                    <AuditLogsIcon /> Audit Logs
                                </Dropdown.Item>
                                <Dropdown.Item
                                    as={Link}
                                    to="/site/chat_history"
                                    state={{ siteId, siteName: domainName }}
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                    <ChatHistoryIcon /> Chat History
                                </Dropdown.Item>
                                <Dropdown.Item
                                    as={Link}
                                    to="/site/configurations"
                                    state={{ siteId, siteName: domainName, userRole }}
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                    <ConfigurationsIcon /> Configurations
                                </Dropdown.Item>
                                <Dropdown.Item
                                    as={Link}
                                    to="/site/customize_chat"
                                    state={{ siteId, siteName: domainName }}
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                    <CustomizeChatIcon /> Customize Chat
                                </Dropdown.Item>
                                <Dropdown.Item
                                    as={Link}
                                    to="/site/excluded_domains"
                                    state={{ siteId, siteName: domainName }}
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                    <ExcludedDomainsIcon /> Excluded Domains
                                </Dropdown.Item>
                                <Dropdown.Item
                                    as={Link}
                                    to="/site/categories"
                                    state={{ siteId, siteName: domainName, siteKey: domainKey }}
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                    <ManageCategoryIcon /> Manage Category
                                </Dropdown.Item>
                                <Dropdown.Item
                                    as={Link}
                                    to="/site/users"
                                    state={{ siteId, siteName: domainName }}
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                >
                                    <ManageUserIcon /> Manage User
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>


                    {/* Right group: refresh and back buttons */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-refresh">Refresh</Tooltip>}
                        >
                            <Button
                                variant="outline-secondary"
                                onClick={refreshData}
                                style={{
                                    background: 'white',
                                    border: '1px solid #ddd',
                                    borderRadius: '50%',
                                    width: '40px',
                                    height: '40px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '0',
                                    fontSize: '14px',
                                    color: '#5a6acf',
                                    cursor: 'pointer',
                                }}
                            >
                                <RefreshIcon />
                            </Button>
                        </OverlayTrigger>


                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-back">Back to Sites</Tooltip>}
                        >
                            <Button
                                variant="outline-secondary"
                                style={{
                                    background: 'white',
                                    border: '1px solid #ddd',
                                    borderRadius: '50%',
                                    width: '40px',
                                    height: '40px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '0',
                                    fontSize: '14px',
                                    color: '#5a6acf',
                                    cursor: 'pointer',
                                }}
                            >
                                <Link
                                    to="/site"
                                    style={{ color: 'inherit', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                    <BackIcon />
                                </Link>
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>


                {showSearchField && (
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
                        <Form.Control
                            type="text"
                            placeholder="Enter search query"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            onKeyDown={handleKeyPress}
                            style={{
                                flex: 1,
                                padding: '8px 12px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                fontSize: '14px'
                            }}
                        />
                        <Button
                            variant="primary"
                            onClick={handleQuerySearch}
                            style={{
                                backgroundColor: '#5a6acf',
                                borderColor: '#5a6acf',
                            }}
                        >
                            Search
                        </Button>
                    </div>
                )}


                {/* Selection info floating modal — bottom-right of screen */}
                {selectedUuids.length > 0 && showSelectionModal && ReactDOM.createPortal(
                    <div style={{
                        position: 'fixed',
                        bottom: '24px',
                        right: '24px',
                        zIndex: 1050,
                        backgroundColor: '#ffffff',
                        border: '1px solid #91c9ff',
                        borderRadius: '12px',
                        padding: '18px 18px 14px 18px',
                        boxShadow: '0 8px 24px rgba(0, 64, 133, 0.18)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minWidth: '320px',
                        maxWidth: '420px',
                        flexWrap: 'wrap',
                        animation: 'slideInUp 0.2s ease-out',
                    }}>


                        {/* Close (X) Button */}
                        <button
                            onClick={() => setShowSelectionModal(false)}
                            style={{
                                position: 'absolute',
                                top: '8px',
                                right: '10px',
                                background: 'none',
                                border: 'none',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                color: '#6c757d',
                                cursor: 'pointer',
                                padding: 0,
                                lineHeight: 1
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#000'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#6c757d'}
                        >
                            ×
                        </button>


                        <style>{`
            @keyframes slideInUp {
                from { opacity: 0; transform: translateY(16px); }
                to   { opacity: 1; transform: translateY(0); }
            }
        `}</style>


                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
                            <div style={{
                                backgroundColor: '#5a6acf',
                                color: '#fff',
                                borderRadius: '50%',
                                width: '28px',
                                height: '28px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 700,
                                fontSize: '13px',
                                flexShrink: 0,
                            }}>
                                {selectedUuids.length}
                            </div>


                            <span style={{ color: '#004085', fontWeight: 500, fontSize: '14px', lineHeight: '1.4' }}>
                                item(s) selected. Use the <strong>Actions</strong> dropdown to delete or retrain the document(s).
                            </span>
                        </div>


                        <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={clearSelection}
                            style={{
                                borderColor: '#5a6acf',
                                color: '#5a6acf',
                                fontSize: '13px',
                                padding: '4px 12px',
                                whiteSpace: 'nowrap',
                                borderRadius: '8px',
                            }}
                        >
                            Clear selection
                        </Button>


                    </div>,
                    document.body
                )}


                {/* Table Section with Checkboxes */}
                <div style={{ overflowX: 'auto', width: '100%' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '1000px' }}>
                        <thead>
                            <tr style={{ textAlign: 'left', fontWeight: 600, fontSize: '14px', color: '#555' }}>
                                {/* Checkbox column */}
                                <th style={{ padding: '14px 4px', borderBottom: '1px solid #f0f0f0', width: '2%', textAlign: 'center', verticalAlign: 'middle' }}>
                                    <input
                                        type="checkbox"
                                        onChange={handleSelectAll}
                                        checked={selectedUuids.length === filteredSiteData.length && filteredSiteData.length > 0}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </th>
                                {(userRole !== "ADMIN") && siteId === 'All' && <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '15%' }}>Client</th>}
                                <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '30%', textAlign: 'center' }}>Document Title</th>
                                <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '20%', textAlign: 'center' }}>Category</th>
                                <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '10%', textAlign: 'center' }}>Status</th>
                                <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '10%', textAlign: 'center' }}>Actions</th>
                                <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '10%', textAlign: 'center' }}>Last Trained</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan={colSpan} style={{ textAlign: 'center', padding: '14px 10px' }}>
                                        <SectionLoader label="Loading documents..." className="revize-section-loader--table" />
                                    </td>
                                </tr>
                            ) : !filteredSiteData.length ? (
                                <tr>
                                    <td colSpan={colSpan} style={{ textAlign: 'center', padding: '14px 10px' }}>
                                        {showPageNumbers
                                            ? (searchInputValue ? 'No documents found matching your search.' : 'No records found!')
                                            : (querySearchTerm ? `No sources found for "${querySearchTerm}".` : 'No sources found.')}
                                    </td>
                                </tr>
                            ) : (
                                filteredSiteData.map((item, index) => (
                                    <tr key={index} style={{ cursor: 'default' }}>
                                        {/* Checkbox cell */}
                                        <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center', verticalAlign: 'middle' }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedUuids.includes(item.uuid)}
                                                onChange={() => handleSelectRow(item.uuid)}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </td>
                                        {(userRole !== "ADMIN") && siteId === 'All' && <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0' }}>{item.website_name}</td>}
                                        <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0' }} title={item.doc_name}>
                                            {truncateText(item.doc_name, 50)} &nbsp;
                                            {item.url.length > 0 ? (
                                                (() => {
                                                    console.log('item.url:', item.url);
                                                    return (
                                                        <a href={item.url} target="_blank" rel="noreferrer">
                                                            <span style={{ color: '#5a6acf' }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        clipRule="evenodd"
                                                                        d="M 19.980469 2.9902344 A 1.0001 1.0001 0 0 0 19.869141 3 L 15 3 A 1.0001 1.0001 0 1 0 15 5 L 17.585938 5 L 8.2929688 14.292969 A 1.0001 1.0001 0 1 0 9.7070312 15.707031 L 19 6.4140625 L 19 9 A 1.0001 1.0001 0 1 0 21 9 L 21 4.1269531 A 1.0001 1.0001 0 0 0 19.980469 2.9902344 z M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 13 A 1.0001 1.0001 0 1 0 19 13 L 19 19 L 5 19 L 5 5 L 11 5 A 1.0001 1.0001 0 1 0 11 3 L 5 3 z"
                                                                        stroke="currentColor"
                                                                        strokeWidth="1"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </span>
                                                        </a>
                                                    );
                                                })()
                                            ) : null}
                                        </td>
                                        <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                                            {item.categories ? (
                                                item.categories.includes(',') ? (
                                                    <Link style={{ textDecoration: 'none' }} onClick={() => handleShowDocumentCategory(item.id, item.uuid, item.url)}>
                                                        {item.categoryCount > 5 ? (
                                                            item.categories.split(',').map((obj, idx) => idx < 5 && (
                                                                <Badge key={Math.random()} bg="light text-dark" style={{ marginRight: '4px' }}>
                                                                    {truncateText(obj.trim(), 20)}
                                                                </Badge>
                                                            ))
                                                        ) : (
                                                            item.categories.split(',').map((obj) => (
                                                                <Badge key={Math.random()} bg="light text-dark" style={{ marginRight: '4px' }}>
                                                                    {truncateText(obj.trim(), 20)}
                                                                </Badge>
                                                            ))
                                                        )}
                                                        {item.categoryCount > 5 ? `+${item.categoryCount - 5}` : null}
                                                    </Link>
                                                ) : (
                                                    <Link style={{ textDecoration: 'none' }} onClick={() => handleShowDocumentCategory(item.id, item.uuid, item.url)}>
                                                        <Badge bg="light text-dark">
                                                            {item.categories}
                                                        </Badge>
                                                    </Link>
                                                )
                                            ) : (
                                                <Link
                                                    style={{
                                                        border: '1px solid #5A3FFF',
                                                        backgroundColor: '#EAF0FF',
                                                        color: '#5A3FFF',
                                                        borderRadius: '6px',
                                                        padding: '4px 8px',
                                                        fontSize: '16px',
                                                        fontWeight: 600,
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: '28px',
                                                        height: '28px',
                                                        cursor: 'pointer',
                                                        textDecoration: 'none',
                                                    }}
                                                    onClick={() => { handleShowDocumentCategory(item.id, item.uuid, item.url) }}
                                                >
                                                    +
                                                </Link>
                                            )}
                                        </td>
                                        <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                                            {item.status === "FAILED" && item.error_cause ? (
                                                <OverlayTrigger placement="top" overlay={<Tooltip>{item.error_cause}</Tooltip>}>
                                                    <button style={getStatusStyle(item.status)}>{item.status}</button>
                                                </OverlayTrigger>
                                            ) : (
                                                <button style={getStatusStyle(item.status)}>
                                                    {item.status === "TO_DELETE" ? "TO DELETE" : item.status}
                                                </button>
                                            )}
                                        </td>
                                        <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                                            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                {filterValue !== "Deleted" && (
                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Retrain</Tooltip>}>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                item.url.length > 0 ? showRetrainModal(item.uuid, item.url, item.status) : handleShowRetrainFile(item.uuid, item.status);
                                                            }}
                                                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#555' }}
                                                        >
                                                            <EditIcon />
                                                        </button>
                                                    </OverlayTrigger>
                                                )}
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            showDeleteModal(item.uuid, item.doc_name);
                                                        }}
                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#555' }}
                                                    >
                                                        <DeleteIcon />
                                                    </button>
                                                </OverlayTrigger>
                                            </div>
                                        </td>
                                        <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                                            {formatTimestamp(item.last_trained)}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>


                {filteredSiteData.length > 0 && showPageNumbers && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '15px', fontSize: '14px', color: '#888', flexWrap: 'wrap', gap: '10px' }}>
                        <div style={{ textAlign: 'left', minWidth: '200px', flex: '1 1 auto' }}>
                            <span>Showing data {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, siteDataLength)} of {siteDataLength} entries</span>
                        </div>


                        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', alignItems: 'center', flexWrap: 'nowrap', overflowX: 'auto', flex: '0 1 auto', maxWidth: '100%', whiteSpace: 'nowrap' }}>
                            <button
                                onClick={handlePrevRange}
                                disabled={currentRangeStart === 1}
                                style={{
                                    padding: '4px 8px',
                                    border: '1px solid #ddd',
                                    borderRadius: '6px',
                                    background: '#fff',
                                    cursor: currentRangeStart === 1 ? 'not-allowed' : 'pointer',
                                    fontSize: '13px',
                                    opacity: currentRangeStart === 1 ? 0.5 : 1,
                                    flexShrink: 0
                                }}
                            >
                                &lt;
                            </button>


                            {visiblePageNumbers.map((number) => (
                                <button
                                    key={number}
                                    onClick={() => paginate(number)}
                                    style={{
                                        padding: '4px 12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        background: currentPage === number ? '#5A6ACF' : '#fff',
                                        color: currentPage === number ? '#fff' : 'inherit',
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        flexShrink: 0
                                    }}
                                >
                                    {number}
                                </button>
                            ))}


                            {currentRangeStart + pagesToShow <= totalPages && (
                                <span style={{ flexShrink: 0 }}>...</span>
                            )}


                            <button
                                onClick={handleNextRange}
                                disabled={currentRangeStart + pagesToShow > totalPages}
                                style={{
                                    padding: '4px 8px',
                                    border: '1px solid #ddd',
                                    borderRadius: '6px',
                                    background: '#fff',
                                    cursor: currentRangeStart + pagesToShow > totalPages ? 'not-allowed' : 'pointer',
                                    fontSize: '13px',
                                    opacity: currentRangeStart + pagesToShow > totalPages ? 0.5 : 1,
                                    flexShrink: 0
                                }}
                            >
                                &gt;
                            </button>
                        </div>


                        <div style={{ textAlign: 'right', minWidth: '200px', flex: '1 1 auto' }}>
                            <label htmlFor="itemsPerPage" style={{ marginRight: '10px' }}>Items per page:</label>
                            <select
                                id="itemsPerPage"
                                value={itemsPerPage}
                                onChange={handleItemsPerPageChange}
                                style={{
                                    padding: '6px 12px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    height: '32px',
                                    width: '80px',
                                    fontSize: '13px',
                                    appearance: 'menulist'
                                }}
                            >
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={150}>150</option>
                                <option value={200}>200</option>
                                <option value={500}>500</option>
                                <option value={1000}>1000</option>
                            </select>
                        </div>
                    </div>
                )}


                {!showPageNumbers && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '15px' }}>
                        <Button
                            onClick={() => {
                                fetchData(filterValue, true, searchInputValue);
                                setShowPageNumbers(true);
                            }}
                            style={{
                                backgroundColor: '#5a6acf',
                                borderColor: '#5a6acf',
                            }}
                        >
                            Show Trained Documents
                        </Button>
                    </div>
                )}


                {/* Modals (unchanged) */}
                <Modal show={showAddFile} onHide={handleCloseAddFile} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Add File</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>File</Form.Label>
                                <Form.Control type="file" onChange={selectFile} />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Category</Form.Label>
                                <Multiselect
                                    options={categoryData}
                                    onSelect={onSelectCategories}
                                    onRemove={onRemoveCategories}
                                    onDropdownToggle={handleDropdownOpen}
                                    placeholder="Select Category"
                                    displayValue="name"
                                    style={{
                                        multiselectContainer: { width: '100%' },
                                        option: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
                                        chips: { background: '#0096fb', color: 'inherit' }
                                    }}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseAddFile} style={{ border: '1px solid #ddd', minWidth: '100px' }}>
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            onClick={() => {
                                addFileDocument();
                                handleCloseAddFile();
                            }}
                            disabled={!selectedFiles.length}
                            style={{
                                backgroundColor: '#5a6acf',
                                borderColor: '#5a6acf',
                                minWidth: '100px'
                            }}
                        >
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showAddUrl} onHide={handleCloseAddUrl} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Add URL</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>URL</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={selectedUrls[0] || ''}
                                    onChange={(e) => checkURLOnCHange(e)}
                                    placeholder="Enter URL"
                                />
                                {urlError && <div style={{ color: 'red' }}>{urlError}</div>}
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Category</Form.Label>
                                <Multiselect
                                    options={categoryData}
                                    onSelect={onSelectCategories}
                                    onRemove={onRemoveCategories}
                                    onDropdownToggle={handleDropdownOpen}
                                    placeholder="Select Category"
                                    displayValue="name"
                                    style={{
                                        multiselectContainer: { width: '100%' },
                                        option: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
                                        chips: { background: '#0096fb', color: 'inherit' }
                                    }}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseAddUrl} style={{ border: '1px solid #ddd', minWidth: '100px' }}>
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            onClick={() => {
                                addUrlDocument();
                                handleCloseAddUrl();
                            }}
                            disabled={!selectedUrls.length || !!urlError}
                            style={{
                                backgroundColor: '#5a6acf',
                                borderColor: '#5a6acf',
                                minWidth: '100px'
                            }}
                        >
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showUpdateFile} onHide={handleCloseUpdateFile} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Update File</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>File</Form.Label>
                                <Form.Control type="file" onChange={updateFile} />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseUpdateFile} style={{ border: '1px solid #ddd' }}>
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            onClick={() => {
                                updateFileDocument();
                                handleCloseUpdateFile();
                            }}
                            disabled={!updatedFiles.length}
                            style={{
                                backgroundColor: '#5a6acf',
                                borderColor: '#5a6acf',
                            }}
                        >
                            Update
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showDocumentCategory} onHide={handleCloseDocumentCategory} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>Category List</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
                                <thead>
                                    <tr style={{ textAlign: 'left', fontWeight: 600, fontSize: '14px', color: '#555' }}>
                                        <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0' }}>Category</th>
                                        <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>Status</th>
                                        <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>Action</th>
                                        <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>Last Trained</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {documentCategoryData.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0' }}>
                                                {item.category}
                                            </td>
                                            <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                                                <button style={getStatusStyle(item.status)}>
                                                    {item.status === "TO_DELETE" ? "TO DELETE" : item.status}
                                                </button>
                                            </td>
                                            <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                                                <button
                                                    onClick={() => showDeleteCategoryModal(item.document_uuid, item.website_ref, item.category_uuid, item.id, item.category)}
                                                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#5a6acf' }}
                                                >
                                                    <DeleteIcon />
                                                </button>
                                            </td>
                                            <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                                                {formatTimestamp(item.last_trained)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <Form.Group className="mb-3">
                            <Form.Label>Category</Form.Label>
                            <Multiselect
                                options={documentCategoryAvailableData}
                                onSelect={onSelectCategories}
                                onRemove={onRemoveCategories}
                                onDropdownToggle={handleDropdownOpen}
                                placeholder="Select Category"
                                displayValue="name"
                                style={{
                                    multiselectContainer: { width: '100%' },
                                    option: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
                                    chips: { background: '#0096fb', color: 'inherit' }
                                }}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDocumentCategory} style={{ border: '1px solid #ddd' }}>
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            disabled={selectedCategories.length === 0}
                            onClick={() => {
                                if (documentUrl.length > 0) {
                                    addDocumentCategoryUrl(documentUuid);
                                } else {
                                    addDocumentCategoryFile(documentUuid);
                                }
                                handleCloseDocumentCategory();
                            }}
                            style={{
                                backgroundColor: '#5a6acf',
                                borderColor: '#5a6acf',
                            }}
                        >
                            Add
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={displayRetrainAllUrlConfirmationModal} onHide={hideRetrainAllUrlConfirmationModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Retrain All URL</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <pre style={{
                            backgroundColor: '#f4f4f4',
                            padding: '10px',
                            borderRadius: '5px',
                            maxHeight: '300px',
                            overflowY: 'auto',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word'
                        }}>
                            {confirmMessage}
                        </pre>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={hideRetrainAllUrlConfirmationModal} style={{ border: '1px solid #ddd' }}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={updateAllUrlDocument} style={{ backgroundColor: '#5a6acf', borderColor: '#5a6acf' }}>
                            Retrain
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={displayRetrainSelectedConfirmationModal} onHide={hideRetrainSelectedConfirmationModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Retrain Selected URLs</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <pre style={{
                            backgroundColor: '#f4f4f4',
                            padding: '10px',
                            borderRadius: '5px',
                            maxHeight: '300px',
                            overflowY: 'auto',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word'
                        }}>
                            {confirmMessage}
                        </pre>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={hideRetrainSelectedConfirmationModal} style={{ border: '1px solid #ddd' }}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={updateSelectedUrlDocuments} style={{ backgroundColor: '#5a6acf', borderColor: '#5a6acf' }}>
                            Retrain
                        </Button>
                    </Modal.Footer>
                </Modal>


                <DeleteConfirmation
                    showModal={deleteAllConfirmationModal}
                    proceedDelete="true"
                    confirmModal={deleteAllDocuments}
                    hideModal={hideDeleteAllConfirmationModal}
                    requireConfirmation={true}
                    message={confirmMessage} />


                <DeleteConfirmation
                    showModal={deleteConfirmationModal}
                    proceedDelete="true"
                    confirmModal={deleteDocument}
                    hideModal={hideDeleteConfirmationModal}
                    uuid={uuid}
                    message={confirmMessage} />


                <DeleteConfirmation
                    showModal={deleteSelectedConfirmationModal}
                    proceedDelete="true"
                    confirmModal={deleteSelectedDocuments}
                    hideModal={() => setDeleteSelectedConfirmationModal(false)}
                    requireConfirmation={true}
                    message={confirmMessage} />


                <DeleteConfirmation
                    showModal={deleteDocumentCategoryConfirmationModal}
                    proceedDelete="true"
                    confirmModal={deleteCategoryDocument}
                    hideModal={hideDeleteDocumentCategoryConfirmationModal}
                    documentUuid={documentUuid}
                    websiteRef={websiteRef}
                    categoryUuid={categoryUuid}
                    categoryDocumentId={categoryDocumentId}
                    message={confirmMessage} />


                <RetrainConfirmation
                    showModal={displayRetrainConfirmationModal}
                    proceedTrain={proceedTrain}
                    confirmModal={updateUrlDocument}
                    hideModal={hideRetrainConfirmationModal}
                    uuid={uuid}
                    url={selectedUrls}
                    message={confirmMessage} />
            </div>
        </div>
    )
}


export default SiteDocs





